import sharingImg from '@/assets/images/share-fill.svg';
import volumeOffImg from '@/assets/images/volumeMute.svg';
import pauseImg from '@/assets/images/pause-fill.svg';
import closeButtonImg from '@/assets/images/closeButton.svg';

export const mobileMenuArea = () => {
  // アイコンコンテナの作成 - flexboxを使用して縦並びに
  const iconsDiv = document.createElement('div');
  iconsDiv.className = 'storeeel-menu-area-icons';
  iconsDiv.style.display = 'flex';
  iconsDiv.style.flexFlow = 'column';
  iconsDiv.style.alignItems = 'center';
  iconsDiv.style.justifyContent = 'flex-end'; // 右寄せにする
  iconsDiv.style.padding = '0 16px';
  iconsDiv.style.gap = '21px'; // 要素間の間隔
  iconsDiv.style.position = 'fixed';
  iconsDiv.style.top = '6%';
  iconsDiv.style.right = '0';
  iconsDiv.style.marginTop = '10px';
  iconsDiv.style.zIndex = '11000';

  // 音量オフアイコンの作成
  const volumeIcon = document.createElement('img');
  volumeIcon.src = volumeOffImg;
  volumeIcon.alt = 'volume';
  volumeIcon.style.width = '24px';
  volumeIcon.style.height = '24px';
  volumeIcon.style.aspectRatio = '1 / 1';
  volumeIcon.style.cursor = 'pointer';
  volumeIcon.setAttribute('data-muted', 'true'); // 初期状態はミュート

  // 共有アイコンの作成
  const sharingIcon = document.createElement('img');
  sharingIcon.src = sharingImg;
  sharingIcon.alt = 'sharing';
  sharingIcon.style.width = '24px';
  sharingIcon.style.height = '24px';
  sharingIcon.style.aspectRatio = '1 / 1';
  sharingIcon.style.height = 'auto';

  // 閉じるボタンの作成
  const closeButton = document.createElement('img');
  closeButton.src = closeButtonImg;
  closeButton.className = 'cross-close-button-parent';
  closeButton.style.display = 'inline-block';
  closeButton.style.verticalAlign = 'middle';
  closeButton.style.position = 'relative'; // position: relativeに変更
  closeButton.style.marginTop= '-8px';
  closeButton.style.width = '24px';
  closeButton.style.height = '24px';
  closeButton.style.aspectRatio = '1 / 1';

  // 2025-05-04一時停止ボタンの作成
  const pauseButton = document.createElement('img');
  pauseButton.src = pauseImg;
  pauseButton.alt = 'pause';
  pauseButton.style.width = '24px';
  pauseButton.style.height = '24px';
  pauseButton.style.aspectRatio = '1 / 1';
  pauseButton.className = 'storeeel-video-control';
  pauseButton.id = 'pause-desktop';
  pauseButton.style.cursor = 'pointer';

  // アイコンをアイコンコンテナに追加 (順番を変更して右から「閉じる」「共有」「音量」の順に)
  iconsDiv.appendChild(closeButton);
  iconsDiv.appendChild(volumeIcon);
   // 2025-05-04一時停止ボタンの生成
  iconsDiv.appendChild(pauseButton);
  iconsDiv.appendChild(sharingIcon);

  const htmlString = `
    ${iconsDiv.outerHTML}
  `;

  return htmlString;
}
